/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Schema from 'docs/components/apis/Schema.vue';

/**
 * This component is used to nicely display API route server responses.
 *
 * @vue-prop {Object[]} responses a list of server responses objects
 * @vue-prop {Object[]} [definitions] a list of definition objects
 *
 * @category docs.components.apis
 * @exports Responses
 * @component
 */
const __vue_script__ = {
    name: 'Responses',

    components: { Schema },

    props: {
        responses: {
            type: Object,
            required: true
        },

        definitions: {
            type: Object,
            default: () => {}
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responses"},[_c('h4',[_vm._v(_vm._s(_vm.$t('api_docs.responses.title')))]),_c('div',{staticClass:"table-wrapper resps"},[_c('table',{staticClass:"table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.responses.code')))]),_c('th',[_vm._v(_vm._s(_vm.$t('api_docs.responses.description')))])])]),_c('tbody',_vm._l((_vm.responses),function(details,code){return _c('tr',[_c('td',{staticClass:"code resp"},[_vm._v(_vm._s(code))]),_c('td',[(details.schema || details.headers)?_c('schema',{attrs:{"schema":details.schema,"definitions":_vm.definitions,"headers":details.headers}},[_c('p',{staticClass:"desc"},[_vm._v(_vm._s(details.description))])]):_c('p',{staticClass:"desc"},[_vm._v(_vm._s(details.description))])],1)])}),0)])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Responses.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__